import { useEffect, useState } from "react";
import Form from "../../../../components/form/Form";
import { useHub, usePreferences } from "../../../../core/Global";
import { AccountGeneralPBXPreferences } from "../../../../models/AccountPreferences";
import { toastSuccess } from "../../../../components/base/Toast";
import Icon from "../../../../components/base/Icon";
import ToggleSwitch from "../../../../components/form/ToggleSwitch";
import TextBox from "../../../../components/form/TextBox";
import PhoneInput from "../../../../components/form/PhoneInput";
import FlexRow from "../../../../components/base/FlexRow";
import Indicator from "../../../../components/base/Indicator";




export default function CallRoutingSettings() {

    const hub = useHub()
    const pref = usePreferences()
    const [working, workingSet] = useState<boolean>(false)
    const [body, bodySet] = useState<AccountGeneralPBXPreferences>()

    useEffect(() => {
        if (pref) bodySet(pref.generalPBXPreferences);
    }, [pref])

    return (
        <Form className="form"
            onSubmit={(e, callback) => {
                workingSet(true);
                hub.Post("/system/Settings/pbxpreferences", body, res => {
                    console.log(res);
                    if (res.success) {
                        toastSuccess("PBX preferences has been updated successfully!");
                    }
                    if (callback) callback(res);
                    workingSet(false);
                });
            }}>
            <div className="card mb-5">
                <div className="card-header border-0">

                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">
                            Call Routing
                        </h3>
                    </div>

                    <div className="card-action">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Updating...</span>
                                    </>
                                    : <>Update Preferences</>
                            }
                        </button>
                    </div>
                </div>
                <div className="card-body border-top px-9 pt-10 pb-4">

                    {
                        pref?.generalPBXPreferences.generalConfigApplied ?
                            <FlexRow className="alert alert-primary mb-10">
                                <Icon icon="check" />
                                <span className="ms-2">
                                    Your configuration is fully updated and no pending changes remain.
                                </span>
                            </FlexRow>
                            :
                            <FlexRow className="alert alert-warning mb-10">
                                <Indicator noText />
                                <span className="ms-2">
                                    Your changes are being applied. Updates will be available shortly.
                                </span>
                            </FlexRow>
                    }

                    <ToggleSwitch label="Automatically forward unanswered calls to another phone number!"
                        name="callsFailOverEnabled" raw small className="mb-5"
                        checked={body?.callsFailOverEnabled}
                        onChange={e => bodySet({
                            ...body,
                            callsFailOverEnabled: e
                        })} />


                    {
                        body?.callsFailOverEnabled &&
                        <div className="mb-5 mt-5 w-500px">

                            <TextBox id="txt-failover-ringtime" key="txt-failover-ringtime" block numeric maxLength={2}
                                label="Ring Time" hint="Set how many seconds the phone should ring before the call is forwarded."
                                iconText="Seconds" value={body?.callsFailOverRingTime}
                                name="callsFailOverRingTime"
                                onTextChanges={e => bodySet({
                                    ...body,
                                    callsFailOverRingTime: Number.parseInt(e)
                                })} />

                            <PhoneInput id="phone-failover-redirect" key="phone-failover-redirect" block
                                label="Destination" defaultPhone={body?.callsFailOverPhone} countryCodes="us-only"
                                name="callsFailOverPhone"
                                onComplete={e => bodySet({
                                    ...body,
                                    callsFailOverPhone: e
                                })}
                            />
                        </div>
                    }





                </div>
            </div>
        </Form>
    )
}